// @flow
import Teams from './Teams';
export default Teams;



// WEBPACK FOOTER //
// ./src/scenes/Teams/index.js